import { Checkbox, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  text: {
    width: '176px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '140%',
    alignItems: 'center',
    color: '#10182B',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  container: {
    width: '278px',
    height: '78px',
    background: '#FFFFFF',
    border: '1px solid #E2E2E2',
    borderRadius: '8px',
    marginBottom: '16px',
    marginRight: '16px',
    marginLeft: '20px',
  },
}));
const CollectionCard = (props) => {
  const classes = useStyles();
  const check = props.selectedArr.filter((item) => item === props.journey?.id);
  const checked = check.length > 0;
  return (
    <Grid container direction="row" justifyContent="space-evenly" alignItems="center" className={classes.container}>
      <Grid item>
        <Image alt="" style={{ width: '42px', height: '62px' }} src={`${props.journey?.thumbnail}`} />
      </Grid>
      <Grid item>
        <Typography className={classes.text}>{props.journey?.title}</Typography>
      </Grid>
      <Grid item>
        <Checkbox id={props.journey?.id} size="small" onChange={props.handleChange} checked={checked} color="primary" />
      </Grid>
    </Grid>
  );
};

export default CollectionCard;
